<template>
  <div class="row d-flex justify-content-center">
    <vue-headful :title="`Account • ${$store.state.settings.settings.site_name}`" />
    <div class="col-lg-8 col-md-12">
      <card>
        <template slot="header">
          <h2 class="mb-2">Personal account</h2>
        </template>
        <tabs
          type="info"
          :value="activeTab">
          <tab-pane
            id="general"
            link="/account/general"
            label="General"
            class="py-4 px-2">
            <account-edit
              :me="me"
              :password-min-length="passwordMinLength"
              @updateMe="updateMe" />
          </tab-pane>
          <tab-pane
            id="settings"
            link="/account/settings"
            label="Settings">
            <account-settings
              :me="me"
              @updateSettings="updateSettings" />
          </tab-pane>
        </tabs>
      </card>
    </div>
    <div class="col-lg-4 col-md-12">
      <user-profile-card :user="me" />
    </div>
  </div>
</template>
<script>
import { TabPane, Tabs } from 'src/components/UI';

import UserProfileCard from 'src/components/UserProfileCard.vue';
import AccountEdit from './AccountEdit.vue';
import AccountSettings from './AccountSettings.vue';

export default {
  name: 'Account',
  props: {
    me: {
      type: Object,
      required: true,
    },
    passwordMinLength: {
      type: Number,
      required: true,
    },
    activeTab: {
      type: String,
      required: true,
    },
  },
  components: {
    TabPane,
    Tabs,
    AccountEdit,
    AccountSettings,
    UserProfileCard,
  },
  methods: {
    updateMe(update) {
      this.$emit('updateMe', update);
    },
    updateSettings(update) {
      this.$emit('updateSettings', update);
    },
  },
};
</script>
